// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/features/object/assign'
import 'core-js/features/array/find'
import 'core-js/features/dom-collections/for-each'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { getContent } from './api/Contentful'
import VueHead from 'vue-head'

require('@/helpers/helper.js')

if (process.env.NODE_ENV === 'production') {
	const log1 = '%c(｡◕‿◕｡) %cHello there! %c(｡◕‿◕｡) \n'
	const log2 = '%chttps://thomasboulongne.com'
	const font = 'font-size: 16px;font-family: -apple - system, BlinkMacSystemFont, \'Segoe UI\', \'Roboto\', \'Oxygen - Sans\', \'Ubuntu\', \'Cantarell\', \'Helvetica Neue\', sans-serif;'
	const style0 = 'color: #ABDBE7; padding-top: 10px; line-height: 30px;' + font
	const style1 = 'padding-top: 10px; color:#666666; line-height: 30px;' + font
	const style2 = font + 'font-weight: 700; color: #444444; line-height: 2; padding: 3px 40px 3px 40px;font-size: 11px'
	console.log(log1, style0, style1, style0)
	console.log(log2, style2)
}

Vue.use(VueHead)
Vue.config.productionTip = false

if (navigator.userAgent.indexOf('Mobi') !== -1) {
	store.dispatch('ui/setMobile')
}

getContent()

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js